import { useParams } from 'react-router-dom'
import useQueryParams from 'utils/hooks/useQueryParams'
import { PANEL_NAVIGATE } from 'modules/Tickets/types'
import { useDispatch } from 'react-redux'
import { useEffect } from 'react'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { useHistory, useRouteMatch } from 'react-router'
import { ROUTES } from 'constants/routes'

const TicketOpener = () => {
  const dispatch = useDispatch()
  const { query: { title = '' } = {} } = useQueryParams()
  const { id } = useParams()
  const pathGen = useGeneratePathI18n()
  const history = useHistory()
  const matched = useRouteMatch()

  useEffect(() => {
    dispatch({
      type: PANEL_NAVIGATE,
      payload: id
        ? {
            route: 'ticket',
            params: { id },
          }
        : {
            route: 'new_ticket',
            params: { id: undefined, title },
          },
    })

    matched.path.match('/:i18n/tickets') &&
      history.push(pathGen(ROUTES.SERVICES))
  }, [])

  return null
}

export default TicketOpener
